<template>
    <div>
        <Menu/>
        <div class="registerContent">
            <div class="form-box">
                <div class="img-box">
                    <img class="img" src="/img/login_bg.png" alt="">
                </div>
                <div class="form">
                    <div class="title">
                        <label>
                            <input type="radio" name="radios" :class="{'active':selectType==1}" v-model="selectType"
                                   value="1"/>
                            注册新账号</label>/
                        <label>
                            <input type="radio" name="radios" :class="{'active':selectType==2}" v-model="selectType"
                                   value="2"/>
                            绑定已有账号</label>
                    </div>
                    <div v-if="this.selectType==1">
                        <div class="item">
                            <span class="iconfont icon-wo"></span>
                            <input type="text" maxlength="20" v-model="registerForm.nickname" placeholder="请输入姓名"/>
                        </div>
                        <div class="item">
                            <span class="iconfont icon-android"></span>
                            <input type="text" maxlength="11" v-model="registerForm.phone" placeholder="请输入您的电话号码"/>
                        </div>
                        <div class="item">
                            <span class="iconfont icon-mima"></span>
                            <input type="password" maxlength="16" v-model="registerForm.pass" placeholder="请输入您的密码"/>
                        </div>
                        <div class="item validateCode">
                            <input type="text" @keyup.enter="registerByOAuth" v-model="registerForm.code" maxlength="6" minlength="1"
                                   placeholder="请输入您的验证码"/>
                            <div class="sendValdateCode" @click="sendSmsCode(registerForm.phone)">获取验证码</div>
                        </div>
                        <div class="agreement">
                            <input type="checkbox" v-model="checked" id="chkAgree"><label
                            for="chkAgree">我已阅读并同意</label> <a class="agreement_page" href="#">《祈山志远健康培训认证会员规则》</a>
                        </div>
                        <div class="register_button" @click="registerByOAuth">
                            马上注册
                        </div>

                    </div>
                    <div v-if="this.selectType==2">
                        <div class="item">
                            <span class="iconfont icon-android"></span>
                            <input type="text" maxlength="11" v-model="connectForm.phone" placeholder="请输入您的电话号码"/>
                        </div>
                        <div class="item validateCode">
                            <input @keyup.enter="connectOAuth" type="text" v-model="connectForm.code" maxlength="6" minlength="1"
                                   placeholder="请输入您的验证码"/>
                            <div class="sendValdateCode" @click="sendSmsCode(connectForm.phone)">获取验证码</div>
                        </div>
                        <div class="register_button" @click="connectOAuth">
                            绑定
                        </div>
                    </div>

                    <div class="go_login">
                        <div>
                            已有帐号？请直接 <a @click="$router.push(`/login`)" href="javascript:void(0)">登录</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
    import Menu from '@/components/Menu2.vue'
    import Footer from '@/components/Footer.vue'
    import {register2, connectAuth, sendSms} from '@/api/account.js'
    import {SMS_TEMPLATE} from "@/constant";

    export default {

        components: {Menu, Footer},

        data() {
            return {
                selectType: 1,//选择类型,1=>注册新账号,2=>绑定已有账号
                checked: false,
                registerForm: {
                    nickname: "",
                    phone: "",
                    code: "",
                    open_id: 0,
                    type: 1,
                },
                connectForm: {
                    phone: "",
                    code: "",
                    open_id: 0,
                    type: 1,
                },


                activeStyle: {
                    color: "red !important",
                }
            }
        },


        mounted() {
            const query = this.$route.query;
            this.registerForm.open_id = query.open_id;
            this.registerForm.type = query.type;
            this.connectForm.open_id = query.open_id;
            this.connectForm.type = query.type;
        },

        methods: {
            registerByOAuth() {
                if (!this.checked) {
                    this.$message("您还未同意会员规则");
                    return;
                }
                register2(this.registerForm).then(rep => {
                    if (rep != -1) {
                        this.$message("恭喜您,注册成功");
                        this.$router.push("/login");
                    }
                });
            },
            connectOAuth() {
                
            },
            sendSmsCode(phone) {
                let smsType = this.selectType == 1 ? SMS_TEMPLATE.REGISTER : SMS_TEMPLATE.AUTH;
                sendSms({phone: phone, type: smsType}).then(rep => {
                    if (rep != -1) {
                        this.$message(`验证码发送成功,有效期:${rep}秒`)
                    }
                });
            },

        },

        watch: {
            checked(newVal, oldVal) {
                console.log(newVal)
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        background: #efefef;
    }


    .registerContent {
        background: #efefef url('/img/login_bg2.png') no-repeat center center;
        margin: 0 auto;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .form-box {
            background: white;
            width: 1000px;
            margin: 60px auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .img-box {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;

                .img {
                    width: 400px;
                    background: #efefef;
                    display: block;
                    margin: 0 auto;
                }
            }

            .form {
                padding: 20px;
                margin: 40px 30px;

                .title {
                    text-align: center;
                    color: #313131;
                    font-weight: bold;
                    font-size: 1.8em;

                    label {
                        cursor: pointer;

                        input[type=radio] {
                            display: none;
                        }

                        .active {
                            color: black !important;
                        }

                    }

                }

                .item {
                    margin: 12px 0;
                    border: 1px solid #bebebe;

                    span {
                        margin-left: 10px;
                        color: #313131;
                    }

                    input {
                        width: 300px;
                        border: 0;
                        outline: none;;;
                        height: 40px;
                        line-height: 40px;
                        padding: 0 10px;
                        color: #101010;
                    }
                }

                .validateCode {
                    position: relative;

                    .sendValdateCode {
                        cursor: pointer;
                        background: #313131;
                        width: 100px;
                        position: absolute;
                        top: 0;
                        right: 0;
                        height: 41px;
                        line-height: 41px;
                        color: white;
                        text-align: center;
                    }
                }

                .agreement {
                    label {
                        color: #767676;
                        font-weight: 1.4em;
                    }

                    .agreement_page {
                        color: #5d9bf9;
                        font-size: 1.4em;
                        text-decoration: underline;
                    }
                }

                .register_button {
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 1.6em;
                    color: white;
                    background: #313131;
                    padding: 10px;
                    text-align: center;
                    margin-top: 30px;
                }

                .go_login {
                    margin: 15px 0;
                    font-size: 1.4em;
                    color: #b8b8b8;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    a {
                        color: #313131;
                    }
                }
            }
        }

        //重置底部margin-top;

    }

    .footer-box {
        margin-top: 0;
    }

</style>
